import PropTypes from 'prop-types';
import React from 'react';
import FaTrash from 'react-icons/lib/fa/trash';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import messages from './messages/PaidFeatures_messages';

import { Input } from '../../components/Form';

const propTypes = {
  editMode: PropTypes.bool.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  keywords: PropTypes.array.isRequired,
};

const CompanyKeywords = ({ editMode, handleUpdate, keywords }) => {
  const renderList = () => keywords.join(', ');

  const renderEditable = () =>
    keywords.map((keyword, index) => (
      <Keyword key={index}>
        <Input
          className="company-keyword-input"
          value={keyword.value}
          onChange={({ target }) => handleUpdate({
            value: target.value, id: keyword.id })}
        />
        {keyword.id !== null && (
          <RemoveIcon
            className="remove-company-keyword-button"
            onClick={() => handleUpdate({
              value: null, id: keyword.id })}
          />
        )}
      </Keyword>
    ));

  return (
    <React.Fragment>
      <h2>
        <FormattedMessage {...messages.searchKeywords} info="Search keywords" />
      </h2>
      {editMode
        ? renderEditable()
        : renderList()
      }
    </React.Fragment>
  );
};

CompanyKeywords.propTypes = propTypes;

const Keyword = styled.div`
  margin-bottom: 6px;
`;

const RemoveIcon = styled(FaTrash)`
  margin-left: 6px;

  &:hover {
    cursor: pointer;
  }
`;

export default CompanyKeywords;
